const Cookies = require('js-cookie');

$(() => {
    let redirect = Cookies.get('sma-redirect');

    if (redirect && window.USER) {
        Cookies.remove('sma-redirect');
        window.location = redirect;
    }
});


// WEBPACK FOOTER //
// ../apps/chide/products/smapply/static/sma.common/base.js